export default "__VITE_ASSET__4f45b4f6__"